import axios from "axios";
import qs from "qs";
import { ElMessage } from "element-plus";
import router from "@/router/index.js";
import store from '@/store/index';
import commonStorage from '@/global/js/comm/storage';
import global from "@/global/js/global";

/**
 * 参考文档 https://github.com/axios/axios
 */

class Request {
    constructor(params) {
        this.baseURL = params.baseURL;
    }

    // 获取axios实例的配置
    getInsideConfig() {
        const config = {
            baseURL: this.baseURL,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "token": commonStorage.get('token')
            },
            timeout: 50000,
            withCredentials: true,
        };
        return config;
    }

    interceptors(instance, tips = {}) {
        // 请求拦截器
        instance.interceptors.request.use(
            (config) => {
                // Do something before request is sent
                return config;
            },
            (error) => {
                // Do something with request error
                return Promise.reject(error);
            }
        );

        // 响应拦截器
        instance.interceptors.response.use(
            (res) => {
                // 关闭加载
                if (tips?.load) global.closeLoading();

                if (res.data.code === 401) {
                    if (router.currentRoute.path !== "/") {
                        router.replace({
                            path: '/'
                        })

                        commonStorage.del('token');
                        commonStorage.del('userInfo');
                        store.dispatch('addloginStatus', { status: true, index: 0 });
                        store.dispatch('addUserInfo', {
                            type: 'all',
                            data: {
                                token: '',
                                info: {}
                            }
                        })
                    }
                }

                switch (res.data.code) {
                    case 200:
                        break;
                    case 400:
                        ElMessage.warning({ showClose: true, message: res.data.msg });
                        break;
                    case 401:
                        break;
                    // 会员
                    case 403:
                        if (tips.msg !== 'none') {
                            ElMessage.error({ showClose: true, message: res.data.msg });
                        }
                        break;
                    // 数据不存在
                    case 404:
                        break;
                    // 未绑定
                    case 1011:
                        break;
                    default:
                        ElMessage.error({ showClose: true, message: res.data.msg });
                        break;
                }

                return res;
            },
            (error) => {
                // 关闭加载
                global.closeLoading();

                return Promise.reject(error);
            }
        );
    }

    // 创建实例
    request(options, tips) {
        if (tips?.load) global.openLoading();

        const instance = axios.create();
        const newOptions = Object.assign(this.getInsideConfig(), options);
        this.interceptors(instance, tips);
        // 等价于 instance.request(newOptions)
        return instance(newOptions);
    }

    get(url, data, tips, config) {
        const options = Object.assign(
            {
                method: "get",
                url: url,
                params: data,
                header: {
                    "token": commonStorage.get('token')
                }
            },
            config,
        );
        return this.request(options, tips);
    }

    post(url, data, tips, type, headers, onDownloadProgress) {
        return this.request({
            method: "post",
            url: url,
            data: type ? data : qs.stringify(data),
            headers: {
                "Content-Type": type
                    ? type
                    : "application/x-www-form-urlencoded",
                "token": commonStorage.get('token'),
                ...headers,
            },
            onDownloadProgress: onDownloadProgress
        }, tips);
    }

    put(url, data, tips, type, headers) {
        return this.request({
            method: "put",
            url: url,
            data: type ? data : qs.stringify(data),
            headers: {
                "Content-Type": type
                    ? type
                    : "application/x-www-form-urlencoded",
                "token": commonStorage.get('token'),
                ...headers,
            },
        }, tips);
    }

    delete(url, data, tips, type, headers) {
        return this.request({
            method: "delete",
            url: url,
            data: type ? data : qs.stringify(data),
            headers: {
                "Content-Type": type
                    ? type
                    : "application/x-www-form-urlencoded",
                "token": commonStorage.get('token'),
                ...headers,
            }
        }, tips);
    }
}

const request = new Request({
    baseURL: process.env.VUE_APP_API_URL,
});

export default request;